<template>
  <pt-hospital-manage class="pt-hospital-manage__withData" @deleteHospital="deleteHospital" ref="table" :companyList="companyList"></pt-hospital-manage>
</template>

<script>
import PtHospitalManage from './index'
export default {
  name: 'pt-hospital-manage__withData',
  components: {
    'pt-hospital-manage': PtHospitalManage
  },
  data () {
    return {
      companyList: []
    }
  },
  methods: {
    getCompanyList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        var newArr = []
        res.data.forEach(ele => {
          var obj = {}
          obj.value = ele.id
          obj.label = ele.fullName
          newArr.push(obj)
        })
        this.companyList = newArr
      }).catch(err => {
        this.$message.error(err || '获取分/子公司列表失败')
      })
    },
    deleteHospital (id) {
      this.$store.dispatch('deleteHospital', id).then(res => {
        this.$message.success('删除医院成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '删除医院失败')
      })
    }
  },
  created () {
    this.getCompanyList()
  }
}
</script>
